import PropTypes from 'prop-types';

const ShieldTickSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 50}`}
      height={`${height || 50}`}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M22.833 4.29163L11.3747 8.5833C9.18717 9.41663 7.39551 12 7.39551 14.3541V31.2291C7.39551 32.9166 8.49967 35.1458 9.85384 36.1458L21.3122 44.7083C23.333 46.2291 26.6455 46.2291 28.6663 44.7083L40.1247 36.1458C41.4788 35.125 42.583 32.9166 42.583 31.2291V14.3541C42.583 12.0208 40.7913 9.41663 38.6038 8.60413L27.1455 4.31246C25.9788 3.85413 24.0205 3.85413 22.833 4.29163Z"
        fill={color}
      />
      <path
        d="M22.2083 29.6458C21.8125 29.6458 21.4167 29.5 21.1042 29.1875L17.75 25.8333C17.1458 25.2291 17.1458 24.2291 17.75 23.625C18.3542 23.0208 19.3542 23.0208 19.9583 23.625L22.2083 25.875L30.0625 18.0208C30.6667 17.4166 31.6667 17.4166 32.2708 18.0208C32.875 18.625 32.875 19.625 32.2708 20.2291L23.3125 29.1875C23 29.5 22.6042 29.6458 22.2083 29.6458Z"
        fill={color}
      />
    </svg>
  );
};

ShieldTickSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ShieldTickSvg;
